const TEST_ENVS_URLS = ['storage.googleapis.com/g-authorized-buyers-creative-previews', 'sdk.sharethrough.com'];

export const isTestEnvironment = () => {
  return TEST_ENVS_URLS.some((testUrl) => window.location.href.indexOf(testUrl) > -1);
};
